/**
 * Creates a data attribute object for scroll ID linking
 * @param id - The unique identifier for the component
 * @returns An object with data-scroll-id attribute if id is provided, empty object otherwise
 *
 * @example
 * ```svelte
 * <div {...setScrollId(id)}>Content</div>
 * ```
 */
export const setScrollId = (id: string | undefined) => {
    if (!id) {
        return {};
    }

    return {
        'data-scroll-id': id,
    };
};
